// Angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// CC-Common imports
import { DxWidgetUtils, IconConstants } from 'cc-common';

// Devextream imports
import { DxPopupComponent } from 'devextreme-angular';
import { Column } from 'devextreme/ui/data_grid';

// Model imports
import { ManageInsuranceHistoryResultDto } from '../../../community-vendor-module/_models/manage-insurance-history-result-dto';
import { VendorContractHistoryResultDto } from '../../_models/vendor-contract-history-result-dto';

@Component({
    selector: 'app-community-vendor-history',
    templateUrl: './community-vendor-history.component.html',
    styleUrls: ['./community-vendor-history.component.scss']
})
export class CommunityVendorHistoryComponent implements OnInit {
    @ViewChild('communityVendorHistoryPopup', { static: false }) communityVendorHistoryPopup: DxPopupComponent;
    @Input() logId: number;
    @Input() historySource: ManageInsuranceHistoryResultDto[] | VendorContractHistoryResultDto[];
    @Input() historyColumns: Column[];
    @Input() communityId: number;
    @Output() onClose = new EventEmitter<void>();

    title: string;
    visible = false;
    iconClose = IconConstants.CLOSE;

    ngOnInit() {
        this.show();
        this.title = `Log of Job ${this.logId}`;
    }

    show(): void {
        this.visible = true;
    }

    onShown(): void {
        DxWidgetUtils.instantRepaint(this.communityVendorHistoryPopup);
    }

    onHidden(): void {
        this.visible = false;
        this.onClose.emit();
    }
}
